import "./ProductItem.css";
import { BsBookmark, BsFillBookmarkFill } from "react-icons/bs";
import { Link, useNavigate, useParams } from "react-router-dom";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import ImageNotFound from "../../Assets/images/ImageNotFound.jpg";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { addToBasket } from "../../Helpers/basketHelper";
import { CartContext } from "../../Hooks/CartContext";

export default function ProductItem({ product, backgroundColor }) {
    const { cartItems, addToCart } = useContext(CartContext);
    const [isLike, setIsLike] = useState(
        product.productSaves?.filter(
            (p) => p.registererId == localStorage.getItem("userId")
        ).length != 0
            ? true
            : false
    );
    const currentDate = new Date()
    const nav = useNavigate();
    function saveProduct() {
        axiosConfig
            .post("api/products/productSave/" + product.id)
            .then((result) => {
                toast.success("با موفقیت محصول سیو شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLike(true);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    toast.warning("وارد حساب کاربری خود شوید", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    nav("/login");
                }
            });
    }
    function deleteSaveProduct() {
        axiosConfig
            .delete("api/products/ProductSave/" + product.id)
            .then((result) => {
                toast.success("با موفقیت محصول سیو شده حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLike(false);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    toast.warning("وارد حساب کاربری خود شوید", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    nav("/login");
                }
            });
    }

    return (
        <div className="product-item">
            <div
                className="product-image"
                style={{ backgroundColor: backgroundColor }}
            >
                <Link to={"/product/" + product.title}>
                    {product.productImages.length != 0 ? (
                        <img
                            src={
                                axiosConfig.defaults.baseURL +
                                "Images/ProductImage/" +
                                product.id +
                                "/" +
                                product.productImages[0].imagePath
                            }
                            alt={product.title}
                        />
                    ) : (
                        <img src={ImageNotFound} alt={product.title} />
                    )}
                </Link>
            </div>
            <Link to={"/product/" + product.title}>
                <div className="product-item-category">
                    <Link to={"/search/all/" + product.category?.title}>
                        <span>{product.category?.title}</span>
                    </Link>
                </div>
            </Link>
            <div className="product-info">
                <Link to={"/product/" + product.title}>
                    <div className="product-title">
                        <h1>{product.title}</h1>
                    </div>
                </Link>
                <Link to={"/product/" + product.title}>
                    {product.discount != null && new Date(product.discount.startTime).getTime() >= currentDate.getTime()
                        && new Date(product.discount.startTime).getTime() <=
                        currentDate.setDate(currentDate.getDate() + parseInt(product.discount.duration)) ? (
                        <div className="product-price">
                            <div className="product-offs">
                                {product.discount.duration}%
                            </div>
                            <div className="prev-price">
                                {product.price?.toLocaleString("fa-IR")}
                            </div>
                            <div></div>
                            {(
                                product.price -
                                (product.price * product.discount.duration) /
                                100
                            ).toLocaleString("fa-IR")}{" "}
                            تومان
                        </div>
                    ) : (
                        product.price == 0 ? (
                            <div className="product-price">
                                <div style={{ color: "green" }}>
                                    رایگان
                                </div>
                            </div>
                        ) : (
                            <div className="product-price">
                                <div>
                                    {product.price?.toLocaleString("fa-IR")} تومان
                                </div>
                            </div>
                        )
                    )}
                </Link>
                <div className="product-btn">
                    <button
                        onClick={async () => {
                            const res = await addToBasket(product.id, 1);
                            if (res) addToCart(cartItems + 1)
                        }}
                        className="product-info-btn"
                    >
                        افزودن به سبد خرید
                    </button>
                </div>
            </div>
            <div className="save-product-icon">
                {isLike == true ? (
                    <BsFillBookmarkFill onClick={deleteSaveProduct} />
                ) : (
                    <BsBookmark onClick={saveProduct} />
                )}
            </div>
        </div>
    );
}
